import { useCallback, useMemo } from "react";
import { apiMain } from "@/common/services";
import { useFetch } from "@/common/hooks/useFetch";
import { metricsBus } from "@/common/buses";
import type { IAdCreator } from "../../AdCreator";

export const usePaidLinksModule = (canRunRequest: boolean) => {
  const fetchPaidLinks = useCallback(() => apiMain.getPaidLinks(), []);
  const { data, isLoading } = useFetch(fetchPaidLinks, canRunRequest);
  const paidLinks = useMemo(() => data?.links || [], [data]);

  const onClickPaidLink = useCallback((username: string) => {
    metricsBus.emit("paidLinksClicked", { username });
  }, []);

  const creators: IAdCreator[] = useMemo(
    () =>
      paidLinks.map((paidLink) => ({
        name: paidLink.title,
        link: paidLink.button_link,
        image: paidLink.image,
        ctaText: paidLink.button_text,
        handleClick: () => onClickPaidLink(paidLink.username)
      })),
    [paidLinks]
  );

  return {
    creators,
    isLoading
  };
};
